import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

// https://github.com/xiaolin/react-image-gallery

class Gallery extends React.Component {
  render() {
    const images = [
      {
        original: "images/gallery_01.jpg",
        description:
          "Senior Minister of State Sim Ann and Mr Lim Teck Yong, Head of People Team at Shopee on stage as they launch the I’m the Best Coder! Challenge 2019.",
        thumbnail: "images/gallery_01.jpg"
      },
      {
        original: "images/gallery_02.jpg",
        description:
          "Senior Minister of State Sim Ann giving her Opening Address at the event. ",
        thumbnail: "images/gallery_02.jpg"
      },
      {
        original: "images/gallery_03.jpg",
        description:
          "Participants of various ages and backgrounds rose to the challenge and coded fervently with the aim of clinching the title of ‘Best Coder’.",
        thumbnail: "images/gallery_03.jpg"
      },
      {
        original: "images/gallery_04.jpg",
        description:
          "A huge shoutout to all of our partners who made this challenge successful!",
        thumbnail: "images/gallery_04.jpg"
      },
      {
        original: "images/gallery_05.jpg",
        description:
          "We are proud to see so many female coders who are defying gender stereotypes.",
        thumbnail: "images/gallery_05.jpg"
      },
      {
        original: "images/gallery_06.jpg",
        description:
          "Shining a spotlight on the award winners! These brilliant tech zealots competed against around 2,500 participants and emerged as the ultimate victors.",
        thumbnail: "images/gallery_06.jpg"
      },
      {
        original: "images/gallery_07.jpg",
        description:
          "Participants had the opportunity to interact with our partner representatives and learn more about their specific challenges and opportunities.",
        thumbnail: "images/gallery_07.jpg"
      },
      {
        original: "images/gallery_08.jpg",
        description:
          "It was a fun-packed day for many participants who compete in the challenge together with their friends.",
        thumbnail: "images/gallery_08.jpg"
      }
    ];

    return (
      <section
        id="gallery"
        style={{ backgroundImage: "Url(images/section-background-02.jpg)" }}
      >
        <div className="container d-flex justify-content-center">
          <div className="col-md-12">
            <div className="section-title">
              <h2>I’m the Best Coder! Challenge 2019 Highlights</h2>
            </div>
            <ImageGallery
              items={images}
              showFullscreenButton={false}
              showPlayButton={false}
              autoPlay={true}
              slideInterval={6000}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default Gallery;
